import { Star } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { companyInfo, reviews } from '../mockData';

export const Reviews = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <section className="bg-gradient-to-br from-blue-600 to-blue-700 text-white py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Customer Reviews</h1>
          <div className="flex items-center justify-center gap-2 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-8 w-8 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
          <p className="text-2xl text-blue-100 mb-2">
            {companyInfo.googleRating} out of 5
          </p>
          <p className="text-lg text-blue-100">
            Based on {companyInfo.reviewCount} verified Google reviews
          </p>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((review) => (
              <Card key={review.id} className="border-gray-200 hover:shadow-lg transition-shadow">
                <CardHeader>
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex gap-1">
                      {[...Array(review.rating)].map((_, i) => (
                        <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                      ))}
                    </div>
                    <span className="text-sm text-gray-500">{review.date}</span>
                  </div>
                  <CardTitle className="text-xl">{review.name}</CardTitle>
                  {review.role && (
                    <p className="text-sm text-gray-500">{review.role}</p>
                  )}
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 leading-relaxed">{review.text}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Google Reviews CTA */}
          <div className="mt-16 text-center bg-white rounded-2xl shadow-lg p-8 lg:p-12 max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              See All Our Reviews on Google
            </h2>
            <p className="text-gray-600 mb-6">
              Read more verified reviews from our satisfied customers on our Google Business profile.
            </p>
            <div className="flex items-center justify-center gap-2 mb-6">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-6 w-6 fill-yellow-400 text-yellow-400" />
              ))}
              <span className="text-lg font-semibold text-gray-900 ml-2">
                {companyInfo.googleRating} / 5.0
              </span>
            </div>
          </div>

          {/* Leave Review Section */}
          <div className="mt-12 bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 lg:p-12 text-center max-w-3xl mx-auto border border-blue-100">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Had a Great Experience?
            </h2>
            <p className="text-gray-600 mb-6">
              We'd love to hear about your experience with {companyInfo.name}. 
              Your feedback helps us continue to provide excellent service.
            </p>
            <p className="text-sm text-gray-500">
              Thank you for choosing Crescent Electrical!
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
